import { Icon, IconActionButton, IconType } from '@aon/aon-tws-common-ui/build/lib/components/Common';
import * as React from 'react';
import styled from 'styled-components';
import { ElementType, IPageFlowElementModel } from '../../../../models';
import { ValidationResultHelper } from '../../../../utilities';

export interface IPageFlowElementDesignRowProps {
	element: IPageFlowElementModel;
	index: number;
	pageFlowValidationHelper: ValidationResultHelper;
	children?: JSX.Element;
	onEdit: (id: number) => void;
	onDelete: (id: number) => void;
}

const ContainerDiv = styled.div.attrs<{ element: IPageFlowElementModel }, any>(() => ({
	className: 'tws-draggable-div',
}))`
	margin-bottom: ${(props) => (props.element.elementType === ElementType.PageBreak ? '0px' : '20px')};
	margin-right: 0px;
	min-width: 500px;
	position: relative;
	display: flex;

	> :last-child {
		padding-left: 4px;
		display: flex;
	}
`;
ContainerDiv.displayName = 'ContainerDiv';

const PageFlowElement = styled.div.attrs<{}>({
	className: 'tws-page-flow',
})`
	align-items: flex-start;
	justify-content: center;
	flex: 1 1 100%;
	-webkit-flex: 1 1 100%;
	-ms-flex: 1 1 105%;
`;
PageFlowElement.displayName = 'PageFlowElement';

const ActionContainerDiv = styled.div.attrs<{}>({})`
	.tws-edit-handle,
	.tws-delete-handle {
		cursor: pointer;
		margin-right: 0px;
		margin-left: 6px;
	}
`;
ActionContainerDiv.displayName = 'ActionContainerDiv';

export const DraggablePageFlowElementRow2 = (props: IPageFlowElementDesignRowProps) => {
	const { element, onEdit, onDelete } = props;

	return (
		<ContainerDiv key={element.id} element={element}>
			<PageFlowElement id={element.id + ''}>{props.children}</PageFlowElement>
			<ActionContainerDiv>
				<IconActionButton label={'edit'} onClick={() => onEdit(element.id)} className={'tws-edit-handle'}>
					<Icon name={IconType.edit} title={'edit'} />
				</IconActionButton>
				<IconActionButton label={'delete'} onClick={() => onDelete(element.id)} className={'tws-delete-handle'}>
					<Icon name={IconType.close} title={'delete'} />
				</IconActionButton>
			</ActionContainerDiv>
		</ContainerDiv>
	);
};
